// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2IyVq","footer":"ModalFilter_footer__1DOSw"};